import { configureStore } from "@reduxjs/toolkit";
import NftReducers from "./reducer/NftReducers";
import AboutService from "./services/AboutService";
import FaqService from "./services/FaqService";
import FeatureService from "./services/FeatureService";
import ImageService from "./services/ImageService";
import NewsletterService from "./services/NewsletterService";
import NftTypeService from "./services/NftTypeService";
import PartnerService from "./services/PartnerService";
import SitesettingService from "./services/SitesettingService";
import RoadMapService from "./services/RoadMapService";
import CommunityService from "./services/CommunityService";

const Store = configureStore({
	reducer: {
		[SitesettingService.reducerPath]: SitesettingService.reducer,
		[FaqService.reducerPath]: FaqService.reducer,
		[AboutService.reducerPath]: AboutService.reducer,
		[PartnerService.reducerPath]: PartnerService.reducer,
		[RoadMapService.reducerPath]: RoadMapService.reducer,
		[CommunityService.reducerPath]: CommunityService.reducer,
		[NewsletterService.reducerPath]: NewsletterService.reducer,
		[FeatureService.reducerPath]: FeatureService.reducer,
		[NftTypeService.reducerPath]: NftTypeService.reducer,
		[ImageService.reducerPath]: ImageService.reducer,
		NftReducers: NftReducers,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat([
			SitesettingService.middleware,
			FaqService.middleware,
			AboutService.middleware,
			PartnerService.middleware,
			RoadMapService.middleware,
			CommunityService.middleware,
			FeatureService.middleware,
			NftTypeService.middleware,
			ImageService.middleware,
		]),
});

export default Store;
